import { createAIDTTheme } from './createAIDTTheme';

import type { PaletteMode, Theme } from '@mui/material';
import type { ElicePaletteName } from '@elice/mui-system';
import { AIDTPaletteLevel, AIDTPalettePublisher, AIDTPaletteSubject } from '../types/theme.types';
import { TypographyFontFamilyType } from '../typography';
import { TYPOGRAPHY_STYLES_MAP } from '../typography/TypographyType';

export interface CreateEliceThemeProps {
  paletteMode?: PaletteMode;
  paletteName?: ElicePaletteName;
  palettePublisher?: AIDTPalettePublisher;
  paletteSubject?: AIDTPaletteSubject;
  paletteLevel?: AIDTPaletteLevel;
  typographyFontFamily?: TypographyFontFamilyType;
  typographyType?: keyof typeof TYPOGRAPHY_STYLES_MAP;
}

/**
 * Override createEliceTheme to use createAIDTTheme instead
 * This ensures the override works in both development and production builds
 */
export const createEliceTheme = ({
  paletteMode = 'light',
  palettePublisher = 'elice',
  paletteSubject = 'korean',
  paletteLevel = 'elementary',
  typographyFontFamily = 'pretendard',
  typographyType = 'Default',
}: CreateEliceThemeProps = {}): Theme => {
  return createAIDTTheme({
    paletteMode,
    palettePublisher,
    paletteSubject,
    paletteLevel,
    typographyFontFamily,
    typographyType,
  });
};

// Re-export the original function as well, in case it's needed
export { createEliceTheme as originalCreateEliceTheme } from '@elice/mui-system';
